import React, { useState } from 'react';
import { motion } from 'framer-motion';
import '../css/HomePage.css';
import '../css/Textos.css';
import Burbuja from '../components/Burbuja';
import PUNTOSBALA from '../components/PuntosBala';
import Velocimetro from '../components/Velocimetro';

// Animación de texto con un delay escalonado
const textVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
};

const HomePage = () => {
  const [autoAccelerate, setAutoAccelerate] = useState(false)
  const imagen = `${process.env.PUBLIC_URL}/images/Formato_web.png`;
  return (
    <div className="container">

      {/* BANNER */}
      <div className="banner-section">
        <img src={`${process.env.PUBLIC_URL}/images/BannerDelta.jpeg`} alt="Banner de la concesionaria" className="banner-image" />
      </div>
      <video
                className="video-movil"
                src={`${process.env.PUBLIC_URL}/images/video.mp4`}
                autoPlay={true}
                muted
                onended="this.pause();"
                playsInline
                style={{ objectFit: "cover", width: "100%" }}
            />

      {/* PRIMERA SECCION */}
      <div className="section principal" style={{"backgroundImage": "url(./images/Formato_web.png)",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center", minHeight: "0px"}}>
        {/* <motion.h1
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0 }}
            variants={textVariants}
        >
            <span>VENDEMOS TU AUTO </span> <br/>
            <span className="underline">SIN COBRAR COMISIÓN</span> <br/>
            <span className="green-text"> EN 30 DÍAS O MENOS  </span> <br/>
            <span className="green-text"> </span>
            POR CONTRATO
        </motion.h1>
        <motion.p
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            variants={textVariants}
        >
            Nos hacemos cargo de absolutamente todo para que vos no tengas que preocuparte de nada.
        </motion.p> */}
        <div className="button-principal" style={{marginTop: "40%", marginLeft: "45%"}}>
          <div className="button-container">
              <div className="velocimetro-container">
                <Velocimetro autoAccelerate={autoAccelerate} />
              </div>
              <motion.button
              className="btn"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              variants={textVariants}
              onClick={() => {setAutoAccelerate("./compra")}}
              >
              QUIERO COMPRAR
              </motion.button>
              <motion.button
              className="btn white"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
              variants={textVariants}
              onClick={() => {setAutoAccelerate("./form")}}  // Botón de venta
              >
              QUIERO VENDER
              </motion.button>
          </div>
        </div>
      </div>


      {/* ITEMS SECCION */}
      <div className="section" style={{backgroundColor: "#fefefe", paddingLeft: "5%"}}>
        {/* <motion.h2
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          variants={textVariants}
          className='titulo-items'
          style={{padding: "0px"}}
        >
          {PUNTOSBALA.length} Razones
        </motion.h2> */}

        <motion.p
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.5 }}
          variants={textVariants}
          className='parrafo-items'
          style={{padding: "0px"}}
        >
          <b>Revolucioná tu experiencia de compra y venta de vehículos.</b>
        </motion.p>

        <div className='contenedor-burbuja' >
            {PUNTOSBALA.map((_, index) => (
                <Burbuja count={index} content={_}/>
            ))}
        </div>
      </div>


      {/* FOTO AUTO SECCION */}
      <div className='contenedor-doble-columna' style={{"backgroundImage": "url(https://cdn.greatsoftwares.com.br/arquivos/paginas_editor/55514-444f90c82936d914bf5378c2e6c6c52c.png)", "backgroundSize": "cover"}}>
      <img src={`${process.env.PUBLIC_URL}/images/auto negro.png`} className="imagen-auto" />
        {/* <div className="section" style={{background: "transparent"}}>
            <motion.h1
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0 }}
                variants={textVariants}
            >
              <p className='titulo-fotos'>
                Vendé o comprá tu próximo auto <b>sin preocuparte</b> de nada, más que de <b>disfrutarlo</b>.
              </p>
            </motion.h1>
            <motion.p
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                variants={textVariants}
                className='detalle-fotos'
            >
                <span className='flecha-fotos'>{">>"} </span>Completá los datos e info de tu auto para que nuestros asesores se contacten con vos en menos de 24hs. <br/><br/>
                <span className='flecha-fotos'>{">>"} </span>Consultá por nuestro inventario o servicio SIN CARGO para que consigamos por vos tu próxima unidad si estás en búsqueda de compra.
            </motion.p>
            <div className="button-container">
                <motion.button
                className="btn"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                variants={textVariants}
                onClick={() => window.location.href = './compra'}  // Botón de venta
                >
                QUIERO COMPRAR
                </motion.button>
                <motion.button
                className="btn white"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
                variants={textVariants}
                onClick={() => window.location.href = './form'}  // Botón de venta
                >
                QUIERO VENDER
                </motion.button>
            </div>
        </div>
        <div className='contenedor-imagen'>
            <img src={`${process.env.PUBLIC_URL}/images/Auto_Azul.jpg`} alt="Banner de la concesionaria" className='imagen-muestra' />
        </div> */}
      </div>


      {/* FOTO CELULAR */}
      <div className='contenedor-doble-columna-centrado' style={{"backgroundImage": "url(https://www.lightning-transportation.com/Images_Content/Site1/Images/Banners/banner-desktop-black-car-service-rochester-ny.jpg)", backgroundSize: "cover", color:"black"}}>
      {/* <div className='contenedor-doble-columna-centrado' style={{"backgroundImage": "url(https://www.wallart.com/media/catalog/product/cache/5b18b93ddbe5d6592c6b175f41d24454/w/0/w02764-small.jpg)", "backgroundSize": "cover", color:"black"}}> */} {/*  ACORDARSE DE SACAR ESTO */}
        {/* <img src="https://cdn.greatsoftwares.com.br/arquivos/paginas_editor/55514-7f64a3329184a90072b8ab52565fb548.png" alt="Banner de la concesionaria" className='imagen-celu'/> */}
        <img src={`${process.env.PUBLIC_URL}/images/celus_delta.jpeg`} alt="Banner de la concesionaria" className='imagen-celu' style={{maxWidth: "400px", borderRadius: "18px"}}/>

        <div className="section" style={{background: "transparent", color:"black", paddingLeft: "40px", maxWidth: "fit-content"}}>
            <motion.h1
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0 }}
                variants={textVariants}
            >
              <p className='titulo-fotos' style={{color: "white", marginTop: "20px"}}> {/*  ACORDARSE DE SACAR ESTO */}
              Completá el formulario en 3 minutos y nuestro equipo de especialistas se encargará de todo. <br/>
              <b>Rápido y sin complicaciones.</b>
              </p>
            </motion.h1>
          
            <div className="button-container">
                <motion.button
                className="btn"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                variants={textVariants}
                onClick={() => window.location.href = './compra'}  // Botón de venta
                >
                QUIERO COMPRAR
                </motion.button>
                <motion.button
                className="btn white"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
                variants={textVariants}
                onClick={() => window.location.href = './form'}  // Botón de venta
                >
                QUIERO VENDER
                </motion.button>
            </div>
        </div>
      </div>


      {/* DIRECCION DEL LUGAR */}
      <div className='contenedor-doble-columna-centrado' style={{"backgroundImage": "url(https://cdn.greatsoftwares.com.br/arquivos/paginas_editor/55514-444f90c82936d914bf5378c2e6c6c52c.png)", "backgroundSize": "cover", justifyContent:"space-around"}}>
        <div className="section" style={{background: "transparent", padding: "10px", width: "fit-content", minHeight: "0px"}}>
            <motion.h1
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0 }}
                variants={textVariants}
            >
              <p className='titulo-fotos' style={{marginBottom: "0px"}}>
                 <b>¡Te esperamos acá!</b>
              </p>
            </motion.h1>
            <motion.p
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                variants={textVariants}
            >
                📍Av Del Libertador 2123, San Fernando, Buenos Aires. <br/><br/>
            </motion.p>
        </div>
        <div className="redes-sociales">
          <a href="https://instagram.com/delta.garageok" target="_blank" rel="noopener noreferrer">
            <i className="icon fab fa-instagram"></i>
            Instagram
          </a>
          <a href="https://twitter.com/deltaGarageOk" target="_blank" rel="noopener noreferrer">
            <i className="icon fab fa-twitter"></i>
            Twitter
          </a>
          <a href="https://tiktok.com/@delta.garageok" target="_blank" rel="noopener noreferrer">
            <i className="icon fab fa-tiktok"></i>
            TikTok
          </a>
        </div>
        {/* <img src={`${process.env.PUBLIC_URL}/images/Libra_icon.jpeg`} alt="Banner de la concesionaria" className='imagen-sponsor' style={{maxWidth: "200px", borderRadius: "18px"}}/> */}
        <div className='mapa' style={{width: "90%"}}>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3290.24454602151!2d-58.5473959!3d-34.4459397!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcaff3486c2697%3A0x541896f15788d0b1!2sDCI%2C%20Av.%20del%20Libertador%202123%2C%20B1646%20San%20Fernando%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses-419!2sar!4v1727804132182!5m2!1ses-419!2sar"allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" className='mapa'></iframe>
        </div>
      </div>

      {/* <div className="section">
        <motion.h2
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 1.2 }}
          variants={textVariants}
        >
          Sección 5
        </motion.h2>
        <motion.p
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 1.4 }}
          variants={textVariants}
        >
          Contenido único de la Sección 5. Testimonios de clientes.
        </motion.p>
      </div> */}
    </div>
  );
};

export default HomePage;
